module.exports = __webpack_public_path__ + "static/media/cams-ncp-logo-placeholder.1299fd40.png";